import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center justify-between mb-5 md:mb-6">
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
          电影分类
        </h3>
        <Link
          to="/category/action"
          className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
        >
          全部类型
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line"></i>
          </div>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-300/30 hover:border-primary-500/50 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-950 transition-all duration-300">
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-300 group-hover:text-foreground-50 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}